import { useWabunkaStateFactory } from '@/composables/utils/wabunka/useWabunkaStateFacroty';
import { sendGAWabunkaAddGuestInfoEvent } from '@/wabunka-src/common/utils/googleAnalytics/events/addGuestInfo';
import { type WabunkaReservationForm } from '@/wabunka-src/features/Experience';

export const useAddGuestInfoGaEvent = (form: Ref<WabunkaReservationForm>) => {
  // GAイベント用
  const addGuestInfoEventSent = useWabunkaStateFactory('addGuestInfoEventSent', false);

  watch(
    () => [
      form.value.step2.firstName,
      form.value.step2.lastName,
      form.value.step2.email,
      form.value.step2.forMyselfPhoneNumber,
      form.value.step2.forMyselfNationality,
      form.value.step2.forSomeoneElsePhoneNumber,
      form.value.step2.forSomeoneElseNationality,
      form.value.step2.shouldShowSomeoneElseForm,
      form.value.step2.participantFirstName,
      form.value.step2.participantLastName,
    ],
    () => {
      const s = form.value.step2;
      const hasPhone = s.shouldShowSomeoneElseForm ? s.forSomeoneElsePhoneNumber !== '' : s.forMyselfPhoneNumber !== '';
      const hasNationality = s.shouldShowSomeoneElseForm ? s.forSomeoneElseNationality !== '' : s.forMyselfNationality !== '';
      const hasParticipantName = s.shouldShowSomeoneElseForm ? s.participantFirstName !== '' && s.participantLastName !== '' : true;
      if (!addGuestInfoEventSent.value && s.firstName !== '' && s.lastName !== '' && s.email !== '' && hasPhone && hasNationality && hasParticipantName) {
        addGuestInfoEventSent.value = true;
        sendGAWabunkaAddGuestInfoEvent(form.value.experienceEvent, form.value.step1);
      }
    },
    { deep: true },
  );
};
